export default {
  projectStatus: null,
  projectName: [],
  customName: [],
  visitPeople: [],
  visitType: null,
  productList: [],
  productObject: {
    pageNumber: 1,
    totalPage: 1,
  },
  productListLoading: false,
  userList: [],
  customType: [],
  contactsType: null,
  hospitalLevel: null,
  doctorTitle: null,
  userAdmins: {},
  homeAuditiongApllyList: {
    results: [],
  },
  customList: {
    results: [],
  },
  serviceLines: [],
  userTeamId: [],
  crmAuth: {},
  clerkList: [],
  signinTeams: [],
  serviceType: [],
  clueSource: [],
  invalidReason: [],
  investigationNature: [],
  investigatType: [],
  receptionLevel: [],
  projectStage: [],
  modeTypeList: [],
  settlementList: [],
  customLevelList: [],
};
